import React, { Component } from 'react'
import FirstViewlist from '../firstviewlist'
import * as styles from './firstview.module.css'

export default class FirstView extends Component {

  render() {
    return (
      <div className={styles.firstview}>
        <p className={styles.firstview_h2}>オッパイ星人の手記＆姉妹サイトおすすめ記事</p>
        <div className={styles.firstview_contents}>
          {/* １列目 */}
          <FirstViewlist target={'bigtiti'} />
          <FirstViewlist target={'bigass'} />
          <FirstViewlist target={'egamishiho'} />
          <FirstViewlist target={'oshikawayuri'} />
          {/* ２列目 */}
          <FirstViewlist target={'kitanomina'} />
          <FirstViewlist target={'koumeena'} />
          <FirstViewlist target={'shibasakiyuri'} />
          <FirstViewlist target={'junelovejoy'} />
          {/* ３列目 */}
          <FirstViewlist target={'zinguzinao'} />
          <FirstViewlist target={'hanyuarisa'} />
          <FirstViewlist target={'neoakari'} />
          <FirstViewlist target={'yayoimiduki'} />
        </div>
      </div>
    )
  }
}